import HidingContext from '@/context/HideContext';
import IHasChildren from '@/types/IHasChildren';
import { FC, useMemo, useState } from 'react';


interface IHideProviderProps extends IHasChildren { }

const HidingProvider: FC<IHideProviderProps> = ({
    children
}) => {

    const [hiding, setHiding] = useState<boolean>(true);

    return (
        <HidingContext.Provider value={{ hiding, setHiding }}>
            {children}
        </HidingContext.Provider>
    )
}

export default HidingProvider